<script>
  import { createEventDispatcher } from "svelte";

  export let key;
  export let name;
  export let count;
  //export let products;

  const dispatch = createEventDispatcher();

  function passKey() {
    dispatch("onCategorySelected", {
      key: key
    });
  }
</script>

<style>
  #category {
    margin: 5px;
    border-radius: 8px;
    background-color: rgb(255, 244, 140);
    cursor: pointer;
    border: 1px solid rgb(255, 115, 0);
    padding: 5px;
    -webkit-box-shadow: -5px -2px 9px 2px rgba(219, 216, 216, 1);
    -moz-box-shadow: -5px -2px 9px 2px rgba(219, 216, 216, 1);
    box-shadow: -5px -2px 9px 2px rgba(219, 216, 216, 1);
  }
  #category > h3 {
    display: inline;
    font-size: 1.4em;
    text-align: center;
    padding: 3px;
    margin: 0 auto;
    color: rgb(245, 60, 4);
    text-align: center;
    border-radius: 8px;
  }
  #category > span {
    float: right;
    padding: 5px;
    font-size: 0.8em;
    background-color: rgb(251, 59, 34);
    color: #fff;
    border-radius: 100%;
  }
</style>

<div id="category" on:click={passKey} on:onCategorySelected>
  <h3>{name}</h3>
  <span>{count}</span>
</div>
